<template>
  <div class="details">
    <div class="appHelmetwde">网点信息<img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="appHelmetreturn()"></div>
    <div class="xqbt-cen">
      <swiper :options="swiperOptions" ref="mySwiper">
        <swiper-slide v-for="item in detada.banner" :key= item.ID><img :src="item.COMPANY_BIG_URL" alt="" class="xqbt-cenig"></swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="xqtb-bk">
      <div class="xqbt-cen-let">
        <p class="xqbt-cen-leta">{{detada.COMPANY_NAME}}</p>
        <p class="xqbt-cen-letb">地址: <span>{{detada.DETAILED_ADDRESS}}</span></p>
        <p class="xqbt-cen-letc">电话: <span>{{detada.PHONE}}</span></p>
      </div>
      <div class="xqbt-cen-rig">
        <div class="xqbt-cen-riga xqbt-cen-rigada" v-on:click="dhxs = !dhxs">
          <img src="../../public/obraoag/wddh.png" alt="">
          <p>电话</p>
        </div>
        <div class="xqbt-cen-rigabk"></div>
        <div class="xqbt-cen-riga xqbt-cen-rigadb" @click="Troadescription()">
          <img src="../../public/obraoag/wddt.png" alt="">
          <p>导航</p>
        </div>
      </div>
    </div>
    <div class="xqbt-btn">
      <p class="xqbt-btna">会员权益</p>
      <p class="xqbt-btnb">一卡通会员尊享会员价</p>
    </div>
    <div class="xqbt-RichText" v-html="detada.HTML_CONTENT"></div>
    <div class="xqbt-dhzz" v-show="dhxs"></div>
    <div class="xqbt-dhzznr" v-show="dhxs">
      <div class="xqbt-dhzznr-pa">{{detada.PHONE}}</div>
      <div class="xqbt-dhzznr-pb">
        <p class="xqbt-dhzznr-pd" v-on:click="dhxs = !dhxs">取消</p>
        <p class="xqbt-dhzznr-pc"><a :href="'tel:' + detada.PHONE">呼叫</a></p>
      </div>
    </div>
    <!-- 微信WeUI样式 -->
    <div class="weui-mask" id="iosMask" style="display: none;" @click="oacancelling()"></div>
    <div class="weui-actionsheet" id="iosActionsheet">
      <div class="weui-actionsheet__menu">
        <div class="weui-actionsheet__cell" @click="decant()">腾讯地图</div>
        <div class="weui-actionsheet__cell" @click="decade()">高德地图</div>
        <!-- <a :href="'https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:' + this.detada.DIMENSIONALITY + ',' + this.detada.PRECISIONS + ';title:' + encodeURI(this.detada.COMPANY_NAME) + ';addr:' + encodeURI(this.detada.DETAILED_ADDRESS) + '&key=A4FBZ-2D5CD-7XF4J-PWFEY-EMXS3-JBB24&referer=obraoapp'" style="color: #000000;" @click="oacancelling()"><div class="weui-actionsheet__cell">腾讯地图</div></a>
        <a :href="'https://m.amap.com/navi/?dest=' + this.detada.PRECISIONS + ',' + this.detada.DIMENSIONALITY + '&destName=' + encodeURI(this.detada.COMPANY_NAME) + '||' + encodeURI(this.detada.DETAILED_ADDRESS) + '&key=020284ca0c0e3c50770494c378c112b8'" style="color: #000000;" @click="oacancelling()"><div class="weui-actionsheet__cell">高德</div></a> -->
      </div>
      <div class="weui-actionsheet__action">
        <div class="weui-actionsheet__cell" @click="oacancelling()">取消</div>
      </div>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + detalong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      commid: '',
      outiuyt: '',
      detada: '',
      dtxs: false,
      dhxs: false,
      delong: '',
      delati: '',
      detalong: 'block',
      swiperOptions: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
        },
      },
    }
  },
  created(){
    this.commid = this.$route.query.commid;
    this.$axios.post('wx/businessdeatils?ID=' + this.commid,this.$qs.stringify({}),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.detalong = 'none';
      this.detada = res.data.dataset;
      // 把获取到的百度地图的经纬度转化为高德地图的经纬度
      var X_PI = Math.PI * 3000.0 / 180.0;
      var x = this.detada.PRECISIONS - 0.0065;
      var y = this.detada.DIMENSIONALITY - 0.006;
      var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
      this.delong = z * Math.cos(theta);
      this.delati = z * Math.sin(theta);
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted(){
    
  },
  methods: {
    // 点击导航选择框出现
    Troadescription(){
      this.$('#iosActionsheet').addClass('weui-actionsheet_toggle');
      this.$('#iosMask').fadeIn(200);
    },
    // 调用腾讯地图
    decant(){
      var deteap = 'https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:' + this.delati + ',' + this.delong + ';title:' + encodeURI(this.detada.COMPANY_NAME) + ';addr:' + encodeURI(this.detada.DETAILED_ADDRESS) + '&key=A4FBZ-2D5CD-7XF4J-PWFEY-EMXS3-JBB24&referer=obraoapp';
      window.plus.runtime.openURL(deteap);
    },
    // 调用高德地图
    decade(){
      var degaap = 'https://m.amap.com/navi/?dest=' + this.delong + ',' + this.delati + '&destName=' + encodeURI(this.detada.COMPANY_NAME) + encodeURI('||') + encodeURI(this.detada.DETAILED_ADDRESS) + '&key=020284ca0c0e3c50770494c378c112b8';
      window.plus.runtime.openURL(degaap);
    },
    // 点击取消选择框消失
    oacancelling(){
      this.$('#iosActionsheet').removeClass('weui-actionsheet_toggle');
      this.$('#iosMask').fadeOut(200);
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/details.css";
</style>